module.exports = __webpack_public_path__ + "fullscreen.svg?dbcb0c84f13ced25204ab3a7d830f3aa";